import * as React from "react";
import {RouteComponentProps} from "react-router";
import {observer} from "mobx-react";
import VacancyRequestAssistantEdit from "./VacancyRequestAssistantEdit";
import VacancyRequestAssistantList from "./VacancyRequestAssistantList";

type Props = RouteComponentProps<{ entityId?: string }>;

@observer
export class VacancyRequestAssistantManagement extends React.Component<Props> {
  static PATH = "/vacancyRequestAssistant";
  static NEW_SUBPATH = "new";

  render() {
    const {entityId} = this.props.match.params;
    return (
      <>
        {entityId ? (
          <VacancyRequestAssistantEdit entityId={entityId}/>
        ) : (
          <VacancyRequestAssistantList/>
        )}
      </>
    );
  }
}
